.imageSkeleton {
  height: 343px;
  width: 100vw;
}

@media all and (--reefer-media-tablet-min) {
  .imageSkeleton {
    height: 644px;
    width: 644px;
  }
}
